import React from 'react'
import { money } from '../financial/formatting'

const CHANNELS = {
  api: { pill: 'API', color: 'var(--channel-api)', soft: 'var(--channel-api-soft)' },
  clicks: { pill: 'CLICKS', color: 'var(--channel-clicks)', soft: 'var(--channel-clicks-soft)' },
}

// The shell both channel cards share: pill, title, campaign line, and the
// channel's earnings top right in its own colour. What goes inside -
// funnel, mini-KPIs, empty state - is the card's own.
export default function ChannelCard({ id, channel, title, block, earningsLabel = 'Your earnings', children }) {
  const theme = CHANNELS[channel]
  const campaigns = block.campaigns || []
  // No payout rate here: a partner is never shown their revenue share.
  const campaignLine = campaigns.length === 1 ? `Campaign ${campaigns[0]}` : `${campaigns.length} campaigns`

  return (
    <section id={id} className="pw-card" aria-label={title} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0, flex: 1 }}>
          <span style={{
            alignSelf: 'flex-start', padding: '3px 9px', borderRadius: 999, fontSize: 10,
            fontWeight: 800, letterSpacing: 1, background: theme.soft, color: theme.color,
          }}>
            {theme.pill}
          </span>
          <h2 className="pw-title" style={{ fontSize: 17, fontWeight: 700 }}>{title}</h2>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{campaignLine}</span>
        </div>
        <div style={{ textAlign: 'right', flexShrink: 0 }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)' }}>{earningsLabel}</div>
          <div className="pw-num pw-title" style={{ fontSize: 26, fontWeight: 800, color: theme.color }}>
            {money(block.earnings)}
          </div>
        </div>
      </div>
      {children}
    </section>
  )
}
